import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { TypePayment } from 'widgets/mplus/mplus-payment/module'

import { AllIcons } from 'shared/ui/app-icon/types'
import { PaymentType } from 'shared/ui/payment-type'

import { ActiveMplusCard } from '../components/active-mplus-card'

import s from './styles.module.scss'

interface Props {
  typePayment?: TypePayment
  onChangeTypePayment?: (type: TypePayment) => void
}

export const MplusAllowed: FC<Props> = ({
  onChangeTypePayment,
  typePayment,
}) => {
  const { t } = useTranslation()

  const onChangeTypePaymentHandler = (type: TypePayment) => {
    if (type !== typePayment) {
      onChangeTypePayment?.(type)
    }
  }

  return (
    <div className={s.container}>
      <PaymentType
        icon={AllIcons.CASH}
        title={t('mplus.pay_current')}
        subTitle={t('mplus.with_trans_mbank')}
        isActive={typePayment === TypePayment.Regular}
        onClick={() => onChangeTypePaymentHandler(TypePayment.Regular)}
      />

      <ActiveMplusCard
        price="0"
        isActive={typePayment === TypePayment.Mplus}
        onClick={() => onChangeTypePaymentHandler(TypePayment.Mplus)}
      />
    </div>
  )
}
